import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { styled } from '@material-ui/core/styles';

export const StyledSelect = styled(Select)(({ theme }) => ({
  border: 'none !important',
  padding: theme.spacing(0),
  '& .MuiSelect-select': {
    backgroundColor: 'transparent !important'
  },
  '& .MuiSelect-icon': {
    top: 'inherit'
  }
}));

export const SelectWithPadding = styled(StyledSelect)(({ theme }) => ({
  padding: theme.spacing(0, 0.5, 1, 0)
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(1, 3)
}));
